/* eslint-disable max-len */
import { useDismissUsernameLoginBanner, useSession } from '@acp/feature/auth';
import {
    Box,
    Button,
    Container,
    HStack,
    Spacer,
    Text,
    useToken,
    VStack,
} from '@chakra-ui/react';

/**
 * Temporary banner shown when the user signed into ACP via Smoke Cake using username login.
 * Remove after username to email login cutover.
 */
export function UsernameLoginBanner() {
    const { showUsernameLoginBanner, complianceUserEmail } = useSession();
    const dismissMutation = useDismissUsernameLoginBanner();
    const colorToken = useToken('colors', 'muted.50');

    if (showUsernameLoginBanner === false) {
        return null;
    }

    const email = complianceUserEmail.trim();

    return (
        <Box backgroundColor="secondary.500" borderBottom={`1px solid ${colorToken}`}>
            <Container maxW="80em" px={5} py={4} w="100%" minW={0} backgroundColor="inherit">
                <HStack gap={10}>
                    <VStack align="left">
                        <Text fontWeight="bold" fontSize="lg" color="white">
                            The way you log in is changing soon.
                        </Text>
                        <Text fontSize="sm" color="white">
                            <Text>
                                From early September we are changing the way you sign in to the Compliance Portal.
                                You will not be able to use your username, and will need to use your email address.
                            </Text>
                            {email !== '' ? (
                                <Text mt={2}>
                                    The email address for your account is:
                                    {' '}
                                    <b>{email}</b>
                                </Text>
                            ) : null}
                        </Text>
                    </VStack>
                    <Spacer />
                    <Button
                        variant="outline"
                        size="sm"
                        colorScheme="secondary"
                        color="white"
                        flexShrink={0}
                        onClick={() => {
                            dismissMutation.mutate();
                        }}
                        isLoading={dismissMutation.isPending}
                    >
                        Dismiss
                    </Button>
                </HStack>
            </Container>
        </Box>
    );
}
